import { render, staticRenderFns } from "./TransportationDetail.vue?vue&type=template&id=6675f97b&"
import script from "./TransportationDetail.vue?vue&type=script&lang=js&"
export * from "./TransportationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports